<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>

    <b-tabs size="is-medium" class="block">
      <b-tab-item label="Individual" icon="keyboard">
        <Form :data="entry" :isEdit="false" @save="save" />
      </b-tab-item>

      <b-tab-item label="Em lote" icon="file-alt">
        <form @submit.prevent="validateBeforeSubmit">
          <p>
            Use o campo abaixo para cadastrar registros em lote. <br />Os campos
            devem ser separados por "," (vírgula), na seguinte ordem: <br />
            <strong>CPF,NOME,DEPARTAMENTO,CÓDIGO INTERNO</strong>
          </p>
          <p><br /></p>
          <b-field
            expanded
            label="Arquivo"
            :type="{ 'is-danger': errors.has('data') }"
            :message="errors.first('data')"
          >
            <b-input
              v-model="entry.data"
              name="data"
              :has-counter="false"
              v-validate="'required'"
              data-vv-as="arquivo"
              type="textarea"
              class="has-double-height"
            />
          </b-field>

          <b-field
            label="Grupo de restrição"
            :type="{ 'is-danger': errors.has('restriction') }"
            :message="errors.first('restriction')"
            expanded
          >
            <b-select
              placeholder="Selecione uma restrição"
              expanded
              v-model="entry.restrictionGroupId"
              v-validate="'required'"
              name="restriction"
              data-vv-as="grupo de restrição"
            >
              <option
                v-for="option in restrictions"
                :value="option.id"
                :key="option.id"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>

          <hr />

          <b-notification
            type="is-danger"
            aria-close-label="Close notification"
            role="alert"
            :active.sync="bulkErrorMessage"
          >
            {{ bulkErrorMessage }}
            <ul v-if="bulkErrorList.length > 1">
              <li v-for="item in bulkErrorList" :key="item.line">
                Linha {{ item.line }}: {{ item.message }}
              </li>
            </ul>
          </b-notification>

          <div class="buttons is-right">
            <router-link
              class="button is-rounded"
              :to="'/motoristas'"
              :disabled="isLoading"
              >Voltar</router-link
            >
            <b-button
              type="is-primary"
              rounded
              :disabled="isLoading"
              :loading="isLoading"
              @click.prevent="validateAndSubmit"
            >
              Salvar
            </b-button>
          </div>
        </form>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import ZHeader from "@/layout/Header";
import Form from "./Form.vue";
import fleetUser from "../../services/fleetUser";
import restrictions from "../../services/restrictions";

export default {
  data() {
    return {
      title: "Adicionar motorista",
      actions: [
        {
          label: "Voltar",
          route: "/motoristas"
        }
      ],
      restrictions: [],
      entry: {},
      isLoading: false,
      bulk: false,
      bulkErrorList: [],
      bulkErrorMessage: null
    };
  },
  mounted() {
    this.loadRestrictions();
  },
  methods: {
    async loadRestrictions() {
      try {
        const response = await restrictions.all();
        this.restrictions = response;

        if (this.restrictions.length > 0) {
          this.entry.restrictionGroupId = this.restrictions[0].id;
        }
      } catch (err) {
        this.$buefy.toast.open({
          message: "Erro ao carregar a lista de restrições.",
          type: "is-danger"
        });
      }
    },
    getRawData() {
      const rawData = { ...this.entry };
      this.bulk = true;
      this.bulkErrorList = [];
      this.bulkErrorMessage = null;
      return rawData;
    },
    async validateAndSubmit() {
      try {
        const result = await this.$validator.validateAll();

        if (result) {
          return this.save(this.getRawData());
        }

        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: "Erro inesperado ao validar os campos.",
          type: "is-danger"
        });
      }
    },
    async save(rawData) {
      this.isLoading = true;
      try {
        if (this.bulk) {
          await fleetUser.bulkCreate(rawData);
          this.bulk = false;
        } else {
          await fleetUser.create(rawData);
        }

        this.isLoading = false;

        this.$router.push({
          name: "fleetUser"
        });
      } catch (err) {
        const {
          response: { data }
        } = err;
        this.isLoading = false;

        if (this.bulk && data.error) {
          this.bulkErrorMessage = data.error.message;
          this.bulkErrorList = data.error.items;
        }

        const message = data.message && data.message.error ? data.message.error : "Erro ao atualizar o motorista";

        this.bulk = false;
        this.$buefy.toast.open({
          message,
          type: "is-danger"
        });
      }
    }
  },
  components: {
    ZHeader,
    Form
  }
};
</script>

<style lang="scss">
.has-double-height {
  .textarea:not([rows]) {
    max-height: 600px;
    min-height: 240px;
  }
}
</style>
